import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import Pillar from "./pillar";
import {toJS} from "../hocs/toJs";

const parsePillar = (pillar) => {
  return {
    id: pillar.get('id'),
    name: pillar.get('name'),
    weightOld: pillar.get('weightOld'),
    weightNew: pillar.get('weightNew'),
    weightNewComing: pillar.get('weightNewComing'),
    createdDate: pillar.get('createdDate'),
  }
};

class PillarHOC extends Component {

  componentDidMount(){
    if(this.props.match.params.id){
      this.props.getPillarById({id:this.props.match.params.id})
    }
  }

  parseForm = (formIM) => {
    return {
      name: formIM.get('name'),
      weightOld: formIM.get('weightOld'),
      weightNew: formIM.get('weightNew'),
      weightNewComing: formIM.get('weightNewComing'),
      createdDate: new Date(),
    }
  };

  submitPillar = (formIM) => {
    const form = this.parseForm(formIM);

    if(this.props.match.params.id){
      delete form.createdDate;
      this.props.updatePillar({
        id:this.props.match.params.id,
        sendBody: form
      })
    } else {
      this.props.createPillar({sendBody: form});
    }

  };

  render(){
    return (
      <Pillar
        {...this.props}
        submitPillar={this.submitPillar}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    pillar: state.pillar.get('pillar'),
    loading: state.pillar.get('fetching') || state.pillar.get('posting') || state.pillar.get('updating'),
    message: state.pillar.get('message')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    createPillar: (payload) => {
      dispatch(actions.createPillar(payload))
    },
    getPillarById: (payload) => {
      dispatch(actions.getPillarById(payload))
    },
    updatePillar: (payload) => {
      dispatch(actions.updatePillar(payload))
    },
    changePillarState: (payload) => {
      dispatch(actions.changePillarState(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PillarHOC));



// WEBPACK FOOTER //
// ./src/components/pillar/pillarHOC.js